module.exports = __webpack_public_path__ + "media/newstyle/images/esboco-b3ac95cf7a0f471215b16db4e2bd7da7.svg";